import styled from "styled-components";

export const Container = styled.div`
  width: auto;
  max-height: 36px;
  padding: 4px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.surface.surface};
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
`;

export const Main = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Row = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
`;

export const Divider = styled.div`
  width: 1px;
  height: 28px;
  padding: 6px;

  .divider {
    width: 1px;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
  }
`;

interface IButtonIcon {
  active?: boolean;
}

export const ButtonIcon = styled.button<IButtonIcon>`
  width: 28px;
  height: 28px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 4px;
  border: none;
  background-color: transparent;
  cursor: pointer;

  .iconButton {
    color: ${({ active, theme }) => active
    ? theme.colors.primary.primary
    : theme.colors.surface.onSurfaceVariant} !important;
  }

  &:hover {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`} !important;
  }
`;
